/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Select_LabelInputs */



/**
* | output |
* | --- |
* | "Select Metadata" |
*
* @param {Event_Group_Metadata_Select_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_select_label = /** @type {((inputs?: Event_Group_Metadata_Select_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Select_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionner des métadonnées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metadaten auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona Metadati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите метаданные")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar metadatos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择元数据")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेटाडेटा का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecionar metadados")
	return /** @type {LocalizedString} */ ("Select Metadata")
});